// "Tell me again what you found."
//
// The two live geometry checks (useOverflowCheck in primitives.jsx, LayoutCheck
// here in shell/) report to the embedding studio by postMessage on a STATE
// TRANSITION — the right contract for the chat's proposal round-trips, which are
// watching a slide change under them.
//
// It is the wrong contract for anything that mounts LATER. The Edit tab opened
// from the red badge is exactly that: the slide settled, reported once, and by
// the time the panel existed there was nothing left to hear. The panel showed an
// empty finding area next to a slide with a red box on it (Jake, 2026-08-02).
//
// So a requester asks and every mounted check answers with what it already
// knows. No re-measure, no polling, no new transport: the deck and the studio
// already share the 'deck-nav::<path>' BroadcastChannel for slide navigation
// (shell/useSlideNav.js, components/PreviewFrame.jsx), and it reaches both
// preview buffers at once, which is what we want — either may be the visible one.
//
// The studio side is studio/src/client/lib/slideChecks.js.

export const CHECKS_REQUEST = 'rkh-checks-request';

/** The channel the deck and the studio share for this preview. */
export function checksChannelName(pathname: string): string {
  return 'deck-nav::' + pathname;
}

/**
 * Call `handler` whenever a studio surface asks for the current findings.
 * Returns an unsubscribe function. Safe to call where BroadcastChannel is
 * missing (older embedded webviews, SSR) — it degrades to a no-op, and the
 * transition reports still work.
 */
export function onChecksRequest(handler: () => void): () => void {
  if (typeof BroadcastChannel === 'undefined') return () => {};
  let ch: BroadcastChannel;
  try {
    ch = new BroadcastChannel(checksChannelName(location.pathname));
  } catch {
    return () => {};
  }
  const onMessage = (e: MessageEvent) => {
    if (e?.data?.type === CHECKS_REQUEST) {
      try {
        handler();
      } catch {}
    }
  };
  ch.addEventListener('message', onMessage);
  return () => {
    try {
      ch.removeEventListener('message', onMessage);
      ch.close();
    } catch {}
  };
}
